module.exports = __webpack_public_path__ + "img/check-active.46f484c5.svg";